module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"FeaturedArticles":{"heading":"Co je nového","linkAllArticles":"Zobrazit všechny články"}}}')
  delete Component.options._Ctor
}
